module.exports = __webpack_public_path__ + "img/governor-horatio-seymour.366deadd.png";